import { Download } from "lucide-react";
import toast from "react-hot-toast";
import { useState } from "react";
import { backupAPI } from "../services/api";
import Dialog from "./Dialog";
import useActionLock from "../hooks/useActionLock";

export default function ExportData() {
  const [open, setOpen] = useState(false);
  const [busy, run] = useActionLock();
  const exportData = () => run(async () => {
    try {
      const { data } = await backupAPI.exportData();
      const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }));
      const link = document.createElement("a");
      link.href = url;
      link.download = `facturalite-export-${new Date().toISOString().split("T")[0]}.json`;
      link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      toast.success("Données exportées");
    } catch { toast.error("Impossible d'exporter les données. Réessayez."); }
  });
  return <>
    <button type="button" className="btn-secondary" onClick={() => setOpen(true)}><Download className="h-4 w-4" />Exporter les données</button>
    {open && <Dialog title="Exporter les données" busy={busy} onClose={() => setOpen(false)} size="max-w-lg">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">Téléchargez vos clients, factures, devis, abonnements et historiques au format JSON. Les fichiers PDF et les secrets de connexion et SMTP sont exclus. Cet export métier ne remplace pas une sauvegarde complète du serveur.</p>
        <button type="button" disabled={busy} className="btn-primary w-full" onClick={exportData}>{busy ? "Export en cours..." : "Télécharger l’export JSON"}</button>
        <div className="rounded-lg bg-gray-50 p-4 text-sm text-gray-600"><p className="font-medium">Restauration indisponible dans l'interface</p><p className="mt-1">La restauration complète s'effectue depuis la sauvegarde du serveur.</p></div>
      </div>
    </Dialog>}
  </>;
}
